import React from 'react';

import { useTranslation } from 'react-i18next';

import PageHeader from '@shared/PageHeader';
import useAdminProductLabelTemplateService from '@hooks/admin/product_label_templates/useAdminProductLabelTemplateService';
import ProductLabelTemplatesEdit from '@shared/product_label_templates/ProductLabelTemplatesEdit';

const AdminProductLabelTemplateNew: React.FC = () => {
  const { t } = useTranslation();
  // useAdminProductLabelTemplateService 是 .js 且 JSDoc 標 `@returns {Object}`，
  // TS 看不到方法欄位，cast 為 any 保留 runtime 行為。
  const {
    getById,
    create,
    update,
    getDefaultTemplate,
  } = useAdminProductLabelTemplateService() as any;

  return (
    <div>
      <PageHeader
        basePath="/admin"
        items={[
          'products',
          'products.label_templates',
          { label: t('shared.product_label_templates.form.new_title') },
        ]}
      />
      <ProductLabelTemplatesEdit
        role="admin"
        getById={getById}
        create={create}
        update={update}
        getDefaultTemplate={getDefaultTemplate}
      />
    </div>
  );
};

export default AdminProductLabelTemplateNew;
